import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActivePreferences, AsyncUserTask } from '../store/userdata.models';

import { environment } from '~/core/core.module';

@Injectable()
export class UserDataService {
  constructor(private readonly http: HttpClient) {}

  public fetchAsyncUserTasks(): Observable<AsyncUserTask[]> {
    // return of([
    //   {
    //     id: '181',
    //     name: 'Dagorde zitting Gemeenteraad op 01/10/2025',
    //     created: '13/10/2025 13:52:50',
    //     completed: '13/10/2025 13:52:59',
    //     availableUntil: '14/10/2025 23:40:00',
    //     type: UserTaskType.GENERATE_PUBLICATION,
    //     status: UserTaskStatus.COMPLETED,
    //     documentId: '68ed043b3e122e3512f4d2e5',
    //     documentName: 'Dagorde zitting Gemeenteraad op 01-10-2025',
    //     documentType: 'pdf',
    //     documentDownloadPath: '/download/userdata/asynctaskdocument/181',
    //     canDownload: false,
    //     inlineView: true,
    //     downloaded: true
    //   }
    // ]);

    return this.http.get<AsyncUserTask[]>(`${environment.BACKEND_URL}/userdata/async-tasks`);
  }

  public deleteAsyncUserTask(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.BACKEND_URL}/userdata/async-tasks/${id}`);
  }

  public fetchPreferences(): Observable<ActivePreferences> {
    return this.http.get<ActivePreferences>(`${environment.BACKEND_URL}/userdata/preferences`);
  }

  public updatePreferences(settings: ActivePreferences): Observable<ActivePreferences> {
    return this.http.post<ActivePreferences>(`${environment.BACKEND_URL}/userdata/preferences`, settings);
  }
}
